import { useIntercom } from '~/_shared/utils/3rdPartyIntegrations/intercom/intercom.context';
import type { ModalProps } from '~/modal/modalType.enum';
import { DataLayerUpgradeModalComponent } from './dataLayerUpgradeModal.component';

export const DataLayerUpgradeModalContainer = (props: ModalProps) => {
  const { show: showIntercom } = useIntercom();

  return (
    <DataLayerUpgradeModalComponent
      onOpenSupportChat={showIntercom}
      {...props}
    />
  );
};
